import { AfterContentChecked, ChangeDetectorRef, Component, HostBinding, Input, TemplateRef } from '@angular/core';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
  standalone: false,
})
export class DropdownButtonComponent implements AfterContentChecked {
  @HostBinding('class')
  private readonly hostClasses = 'flex flex-row items-center cursor-pointer relative w-full border-navy-60 hover:border-navy-90 bg-white font-main text-base h-10 border rounded-md py-0 px-2.5';

  tooltipPlacement: PlacementArray = 'top';

  @Input()
  value: string;

  @Input()
  pinnedLabel: string;

  @Input()
  placeholder: string;

  @Input()
  isLoading: boolean;

  @Input()
  showTooltipAlwaysOnHover = false;

  @Input()
  customTooltip: string | TemplateRef<any>;

  @Input()
  iconNextToValue?: string;

  @HostBinding('class.open')
  @HostBinding('class.border-navy-90')
  @Input()
  isOpen: boolean;

  @HostBinding('class.pointer-events-none')
  @HostBinding('class.disabled')
  @Input()
  disabled: boolean;

  @Input()
  disabledFilterState? = false;

  get tooltip(): string | TemplateRef<any> {
    return this.customTooltip || this.value;
  }

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }
}
